import { TOP_SEARCHED_SPECIES } from '../../../constants/species/topSearchedSpecies';
import { getSpeciesUrl } from '../../../helpers/urls';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { ChevronDownIcon } from '../../Icons/ChevronDownIcon';
import { ChevronUpIcon } from '../../Icons/ChevronUpIcon';
import { Text } from '../../Text/Text';

export const SEOSpeciesLink = () => {
  return (
    <div className="relative flex w-full flex-wrap gap-2 sm:mb-8 sm:pr-6">
      <input type="checkbox" id="SEOSpeciesLink-checkbox" className="peer hidden" />
      {TOP_SEARCHED_SPECIES.map((specie, index) => {
        const isHidden = index > 4;
        const { externalId, commonName } = specie;
        return (
          <InternalLink
            variant="textPrimary"
            className={`bg-sea-foam flex h-min w-max items-center rounded-lg p-2 ${isHidden ? 'hidden peer-checked:flex' : ''}`}
            to={getSpeciesUrl(externalId, commonName)}
            key={`SEOSpeciesLink-${externalId}`}
          >
            <Text variant="sm" className="mb-0">
              {commonName}
            </Text>
            <ArrowRightIcon className="ml-1" size={14} />
          </InternalLink>
        );
      })}
      <label
        htmlFor="SEOSpeciesLink-checkbox"
        className="text-deep-sea flex w-full cursor-pointer items-center justify-center py-3 peer-checked:hidden sm:absolute sm:right-0 sm:w-auto sm:py-0"
      >
        <ChevronDownIcon />
        <span className="sr-only">Show more</span>
      </label>
      <label
        htmlFor="SEOSpeciesLink-checkbox"
        className="text-deep-sea hidden w-full cursor-pointer items-center justify-center py-3 peer-checked:flex sm:absolute sm:right-0 sm:w-auto sm:py-0"
      >
        <ChevronUpIcon />
        <span className="sr-only">Show less</span>
      </label>
    </div>
  );
};
